import { useParams } from 'react-router-dom'
import { Layout } from '@/shell/Layout'
import type { OrgItem } from '@/lib/apiTypes'
import { useOrgs } from '@/lib/hooks'
import { EmptyState } from '@/shared/components/EmptyState'
import { PolicyTabs } from '@/features/policies/tabs/PolicyTabs'
import {  ROLE_RANK } from '@/features/policies/tabs/policyScopes'

export function PoliciesOverview() {
  const { orgSlug } = useParams()
  const orgs = useOrgs()
  const org = orgs.data?.orgs.find((o) => (o.slug ?? o.id) === orgSlug)

  return (
    <Layout title={<>Policies <span className="badge badge-amber">Experimental</span></>}>
      {org ? (
        <OrgPolicySection org={org} />
      ) : (
        !orgs.loading && <EmptyState icon="⬡" title="No organisations yet." />
      )}
    </Layout>
  )
}

function OrgPolicySection({ org }: { org: OrgItem }) {
  const rank     = ROLE_RANK[org.role] ?? 0
  const canAdmin = ['owner', 'admin'].includes(org.role)
  const isOwner  = org.role === 'owner'

  // Gate before mounting anything so a reader never triggers the policies fetch.
  if (rank < 2) {
    return <EmptyState icon="🔒" title="Access restricted" subtitle="Policies are only visible to org members and above." />
  }

  // This page is reachable for a personal workspace (it gates on role alone, unlike the Org
  // settings panel), and a personal workspace cannot have policies at all - so it must never be
  // offered a baseline it would then be refused.
  const canOfferBaseline = canAdmin && org.is_personal !== 1

  return <PolicyTabs orgId={org.slug} canAdmin={canAdmin} isOwner={isOwner} canOfferBaseline={canOfferBaseline} />
}
